import { MetadataDiagram } from './metadata-diagram.model';
export class Metadata {
public Diagrams: MetadataDiagram[];
public Label: string;
  }

function Metadata_tsickle_Closure_declarations() {
/** @type {?} */
Metadata.prototype.Diagrams;
/** @type {?} */
Metadata.prototype.Label;
}

